/**
 * Manutenzioni — riuso completo della pagina Cantieri con tipo="manutenzione".
 * Stessa logica, stesse funzionalità, dati separati (filtro sulla stessa
 * collezione via campo `tipo`).
 */
import React from "react";
import Cantieri from "@/pages/Cantieri";

export default function Manutenzioni() {
  return <Cantieri tipo="manutenzione" label="Manutenzioni" labelSingolare="Manutenzione" articoloIndet="Nuova" />;
}
